import React, {
  // useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
// import { FaPaperclip } from "react-icons/fa";
// import Avatar from "react-avatar";
// import moreIco from "../../Assets/Images/moreIco.png";
import caretDrop from "../../Assets/Images/caretDrop.png";
import chatbotHeader from "../../Assets/Images/chatbotheader.png";
import logo from "../../Assets/Images/Logo.png";
import "./ChatBotMessage.css";
// import submitIco from "../../Assets/Images/SubmitIco.png";
// import echo from "../../Helpers/echo";
import pusher from "../../Helpers/pusher";
import { ColorRing } from "react-loader-spinner";
import { GetUserDetails } from "../../Helpers/Utility";
import { getUserChat, sendingMessage } from "../../Services/ChatApi";
import ChatCircleIcon from "./ChatCircleIcon";
import InfiniteScroll from "react-infinite-scroll-component";
import { FaPaperclip } from "react-icons/fa";
// import { FaXmark } from "react-icons/fa6";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileImage,
  faFile,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

export default function ChatBotMessage() {
  const userDetails = useMemo(() => {
    return GetUserDetails();
  }, []);

  const [messages, setMessages] = useState([
    {
      id: -1,
      message: "Welcome to VPN chatbot!",
      receiver_id: userDetails?.id,
      sender_id: process.env.REACT_APP_ADMIN_ID,
    },
  ]);
  const [newMessage, setNewMessage] = useState("");
  const [isChatBotVisible, setIsChatBotVisible] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [isSendingMessage, setisSendingMessage] = useState(false);

  const [totalChatPage, setTotalChatPage] = useState(1);
  const [currentChatPage, setCurrentChatPage] = useState(0);

  const chatContainerRef = useRef(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const fileIcons = {
    pdf: faFilePdf,
    doc: faFileWord,
    docx: faFileWord,
    xls: faFileExcel,
    xlsx: faFileExcel,
    jpeg: faFileImage,
    jpg: faFileImage,
    png: faFileImage,
    gif: faFileImage,
    default: faFile,
  };

  const getFileIcon = (fileType) => {
    return fileIcons[fileType] || fileIcons["default"];
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedFile(file);
      const fileExtension = file.name.split(".").pop();
      setSelectedFile({
        name: file.name,
        type: fileExtension,
        url: URL.createObjectURL(file),
      });
    }
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setUploadedFile(null);
  };

  useEffect(() => {
    // Request permission on page load
    // if (Notification.permission !== 'granted') {
    //   Notification.requestPermission();
    // }

    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [isChatBotVisible]);

  const getChats = async (replace = false) => {
    if (userDetails) {
      const res = await getUserChat(
        process.env.REACT_APP_ADMIN_ID,
        replace ? 1 : currentChatPage + 1
      );
      setCurrentChatPage((pg) => (replace ? 1 : pg + 1));
      setTotalChatPage(res?.data?.data?.totalPageCount);
      if (res?.data?.data?.messages?.length) {
        if (replace) setMessages(res?.data?.data?.messages);
        else
          setMessages((prevMsg) =>
            [...prevMsg, ...res?.data?.data?.messages].filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
            )
          );
      } else
        setMessages([
          {
            id: -1,
            message: "Welcome to VPN chatbot!",
            receiver_id: userDetails.id,
            sender_id: process.env.REACT_APP_ADMIN_ID,
          },
        ]);
    } else {
      setMessages([
        {
          id: -1,
          message: "Welcome to VPN chatbot!",
          receiver_id: userDetails?.id,
          sender_id: process.env.REACT_APP_ADMIN_ID,
        },
      ]);
    }
  };

  useEffect(() => {
    if (showChat) {
      const channel = pusher.subscribe("chat");
      channel.bind("App\\Events\\MessageSent", function (data) {
        if (data.length) {
          var msg = data[0];
          if (msg.receiver_id === userDetails.id) {
            setMessages((prevMessages) => [msg, ...prevMessages]);
            if (chatContainerRef.current) {
              chatContainerRef.current.scrollTop =
                chatContainerRef.current.scrollHeight;
            }
            setIsChatBotVisible(true);
            // send notification
            if ("safari" in window && "pushNotification" in window.safari) {
            } else if ("Notification" in window) {
              if (window.Notification.permission === "granted") {
                navigator.serviceWorker.ready.then((registration) => {
                  registration.showNotification(
                    `123MyVPN - ${msg.sender_name}`,
                    {
                      body: msg.message,
                      icon: logo,
                    }
                  );
                });
              } else if (window.Notification.permission !== "denied") {
                window.Notification.requestPermission().then(function (
                  permission
                ) {
                  if (permission === "granted") {
                    navigator.serviceWorker.ready.then((registration) => {
                      registration.showNotification(
                        `123MyVPN - ${msg.sender_name}`,
                        {
                          body: msg.message,
                          icon: logo,
                        }
                      );
                    });
                  }
                });
              }
            }
          }
        }
      });

      return () => {
        pusher.unsubscribe("chat");
      };
    }
  }, [showChat]);

  useEffect(() => {
    if (!userDetails || userDetails?.isAdmin) {
      setShowChat(false);
      return;
    }
    setShowChat(true);
    if (isChatBotVisible) getChats(true);
  }, [userDetails, isChatBotVisible]);

  const handleSendMessage = async () => {
    setisSendingMessage(true);
    if (newMessage.trim() !== "" || uploadedFile != null) {
      // setMessages([...messages, { sender: "user", text: newMessage }]);
      setNewMessage("");
      // await sendingMessage(
      //   process.env.REACT_APP_ADMIN_ID,
      //   newMessage
      // );
      const formData = new FormData();
      if (uploadedFile) formData.append("file", uploadedFile);
      formData.append("receiver_id", process.env.REACT_APP_ADMIN_ID);
      formData.append("message", newMessage);

      await sendingMessage(formData);
      setCurrentChatPage(0);
      handleRemoveFile();
      // setMessages([...messages, response.data]);
      getChats(true);
    }
    setisSendingMessage(false);
  };

  const handleInputChange = (e) => {
    setNewMessage(e.target.value);
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setMessages([
  //       ...messages,
  //       { sender: "user", text: `Uploaded file: ${file.name}` },
  //     ]);
  //   }
  // };

  const toggleChatBotVisibility = () => {
    setIsChatBotVisible(!isChatBotVisible);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSendMessage();
    }
  };

  return showChat ? (
    <>
      <ChatCircleIcon onClick={toggleChatBotVisibility} />
      {isChatBotVisible && (
        <div style={styles.chatBotContainer}>
          <div className="chatbot-header p-3 pb-2">
            <div className="d-flex align-items-center">
              <div>
                <img src={chatbotHeader} className="img-fluid" alt="header" />
              </div>
              <div className="ps-3">
                <div className="fw-medium font-inherit">Customer Support</div>
                <div className="text-start fw-light">Ask us anything!</div>
              </div>
              <div className="d-flex ms-auto">
                {/* <div className="px-2">
                  <img
                    src={moreIco}
                    className="cursor-pointer img-fluid"
                    alt="more"
                  />
                </div> */}
                <div className="px-2" onClick={toggleChatBotVisibility}>
                  <img
                    src={caretDrop}
                    className="cursor-pointer img-fluid"
                    alt="caret"
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            ref={chatContainerRef}
            id="floatingMsgContainer"
            style={styles.inputContainer}
          >
            <InfiniteScroll
              dataLength={messages.length}
              next={getChats}
              hasMore={currentChatPage < totalChatPage && messages.length !== 0}
              style={{
                display: "flex",
                flexDirection: "column-reverse",
                maxHeight: "calc(100dvh - 350px)",
                paddingLeft: "5px",
                paddingRight: "5px",
                overflowX: "hidden",
              }}
              height={600}
              loader={
                <div className="d-flex justify-content-center w-full">
                  <ColorRing
                    type="ThreeDots"
                    color="#00BFFF"
                    height={50}
                    width={50}
                  />
                </div>
              }
              inverse={true}
              scrollableTarget="floatingMsgContainer"
            >
              {messages.map((message) => (
                <div
                  key={message.id}
                  style={
                    message.sender_id !== userDetails.id
                      ? styles.botMessageContainer
                      : styles.userMessageContainer
                  }
                >
                  {/* <div style={styles.avatarContainer}>
                    {message.sender_id !== userDetails.id ? (
                    <img src={chatbotHeader} style={styles.avatar} alt="bot" />
                  ) : (
                    <Avatar
                      name={userDetails?.name}
                      size="40"
                      className="ms-1"
                      round={true}
                    />
                  )}
                  </div> */}

                  {message.is_file == 1 && (
                    <div
                      style={
                        message.sender_id !== userDetails.id
                          ? styles.botMessage
                          : styles.userMessage
                      }
                    >
                      <span
                        className="file"
                        style={
                          message.sender_id !== userDetails.id
                            ? styles.botFileMessageLink
                            : styles.userFileMessageLink
                        }
                      >
                        <FontAwesomeIcon
                          icon={getFileIcon(message.file_type)}
                        />
                        <a
                          href={message.file_url}
                          target="_blank"
                          style={
                            message.sender_id !== userDetails.id
                              ? styles.botFileMessageLink
                              : styles.userFileMessageLink
                          }
                          rel="noopener noreferrer"
                        >
                          {message.file_name}
                        </a>
                        <a
                          href={message.file_url}
                          download={message.file_name}
                          style={
                            message.sender_id !== userDetails.id
                              ? styles.botFileMessageLink
                              : styles.userFileMessageLink
                          }
                        >
                          <FontAwesomeIcon
                            icon={faDownload}
                            style={{ marginLeft: "10px", cursor: "pointer" }}
                          />
                        </a>
                      </span>
                    </div>
                  )}
                  {message?.message != "" && message?.message != null && (
                    <div
                      style={
                        message.sender_id !== userDetails.id
                          ? styles.botMessage
                          : styles.userMessage
                      }
                    >
                      <span
                        style={
                          message.sender_id !== userDetails.id
                            ? styles.botFileMessageLink
                            : styles.userFileMessageLink
                        }
                      >
                        {message.message}
                      </span>
                    </div>
                  )}
                  <div>
                    <span
                      style={
                        message.sender_id !== userDetails.id
                          ? styles.botMessageTime
                          : styles.userMessageTime
                      }
                    >
                      {message?.updated_at &&
                        new Date(message.updated_at).toLocaleString("en-US", {
                          hour: "numeric",
                          minute: "numeric",
                          hour12: true,
                        })}
                    </span>
                  </div>
                </div>
              ))}
            </InfiniteScroll>
          </div>
          <div
            style={{
              ...styles.inputContainer,
              display: "flex",
              overflow: "inherit",
            }}
          >
            {/* <label htmlFor="fileUpload" className="pt-2">
              <FaPaperclip style={styles.uploadIcon} />
            </label>
            {selectedFile && (
              <div className="selected-file">
                <FontAwesomeIcon icon={getFileIcon(selectedFile.type)} />
                <a href={selectedFile.url} target="_blank" rel="noopener noreferrer">
                  {selectedFile.name}
                </a>
                <button onClick={handleRemoveFile}>Remove</button>
              </div>
            )} */}
            <textarea
              type="text"
              value={newMessage}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
              placeholder="Type a message..."
              rows={1}
              style={{ ...styles.input, resize: "none" }}
              disabled={isSendingMessage}
            />
            {/* <input
              type="file"
              id="fileUpload"
              style={styles.fileInput}
              onChange={handleFileChange}
            />  */}
            <button onClick={handleSendMessage} style={styles.sendButton}>
              Send
            </button>
          </div>
        </div>
      )}
    </>
  ) : (
    <></>
  );
}

const styles = {
  chatBotContainer: {
    position: "fixed",
    bottom: "80px",
    right: "20px",
    width: "360px",
    height: "500px", // Adjusted height here
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    zIndex: "1000",
  },
  messagesContainer: {
    flex: 1,
    overflowY: "auto",
    marginBottom: "10px",
    padding: "20px 10px",
  },
  botMessageContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
  },
  userMessageContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "21px",
    justifyContent: "flex-start",
    flexDirection: "row-reverse",
  },
  avatarContainer: {
    marginRight: "10px",
  },
  avatar: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
  },
  botMessage: {
    position: "relative",
    backgroundColor: "#fff",
    border: "1px solid #E5E5E5",
    padding: "9px 10px 8px 10px",
    borderRadius: "10px",
    maxWidth: "60%",
  },
  userMessage: {
    position: "relative",
    backgroundColor: "#16A34A",
    color: "#fff",
    padding: "8px",
    borderRadius: "10px",
    maxWidth: "60%",
  },
  userMessageTime: {
    // position: "absolute",
    position: "relative",
    right: "5px",
    bottom: "0px",
    color: "#414141",
    fontSize: "11px",
    whiteSpace: "nowrap",
  },
  botMessageTime: {
    // position: "absolute",
    position: "relative",
    left: "6px",
    bottom: "0px",
    color: "#414141",
    fontSize: "11px",
    whiteSpace: "nowrap",
  },
  inputContainer: {
    // display: "flex",
    // alignItems: "center",
    overflow: "auto",
    padding: "10px 10px",
    backgroundColor: "#f8faff",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
  },
  input: {
    flex: 1,
    padding: "8px",
    borderRadius: "20px",
    border: "1px solid #16A34A",
    marginRight: "10px",
  },
  fileInput: {
    display: "none",
  },
  uploadIcon: {
    fontSize: "20px",
    marginRight: "10px",
    cursor: "pointer",
  },
  sendButton: {
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "20px",
    padding: "8px 16px",
    cursor: "pointer",
  },
  fileMessage: {
    display: "flex",
    alignItems: "center",
  },
  botFileMessageLink: {
    marginLeft: "5px",
    textDecoration: "none",
    color: "#16a34a",
  },
  userFileMessageLink: {
    marginLeft: "5px",
    textDecoration: "none",
    color: "#f8f9fa",
  },
};
